import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/auth.service';

interface AdminHeaderProps {
  user: any;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ user }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const handleLogout = () => {
    AuthService.logout();
    // navigate('/login');
    window.location.href = '/';
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 py-1">
      <div className="max-w-screen-xl mx-auto px-3 sm:px-4 lg:px-6">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo and Branding Section */}
          <div className="flex items-center min-w-0 flex-1">
            <div className="flex items-center space-x-2 sm:space-x-4">
              {/* University Logos */}
              <div className="flex items-center space-x-2 sm:space-x-3">
                <img 
                  src="/images/logo-uor.png" 
                  alt="University Logo" 
                  className="h-8 sm:h-10 w-auto flex-shrink-0"
                />
                <div className="h-6 sm:h-8 w-px bg-gray-300 hidden xs:block"></div>
                <img 
                  src="/images/logo-eng.png" 
                  alt="Faculty Logo" 
                  className="h-8 sm:h-10 w-auto flex-shrink-0 hidden xs:block"
                />
              </div>
              
              {/* Title Section - Responsive */}
              <div className="ml-2 sm:ml-4 min-w-0">
                <div className="text-sm sm:text-lg lg:text-xl font-normal text-gray-900 tracking-tight truncate">
                  <span className="hidden sm:inline">Faculty of Engineering</span>
                  <span className="sm:hidden">REF Portal</span>
                </div>
                
                <div className="text-xs sm:text-sm text-gray-600 font-normal mt-0.5 truncate hidden sm:block">
                  Maintenance, Requests and Complaints Management System
                </div>
              </div>
            </div>
          </div>

          {/* Desktop Right Section */}
          <div className="hidden md:flex items-center space-x-4 flex-shrink-0">
            {/* User Profile Section */}
            <div className="flex items-center space-x-3">
              {/* User Avatar */}
              <div className="relative">
                <div className="h-8 w-8 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-sm font-medium">
                    {user?.email ? user.email.charAt(0).toUpperCase() : 'A'}
                  </span>
                </div>
              </div>
              
              {/* User Info */}
              <div className="text-left flex flex-col justify">
                {/* <div className="text-sm font-medium text-gray-900">Administrator</div> */}
                <div className="text-xs text-gray-500 max-w-32 truncate ">
                  {user?.email || 'admin@example.com'}
                </div>
              </div>
            </div>

            {/* Divider */}
            <div className="h-6 w-px bg-gray-300"></div>

            {/* Desktop Logout Button */}
            <button
              onClick={handleLogout}
              className="inline-flex items-center px-3 lg:px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-150 ease-in-out"
            >
              <svg 
                className="w-4 h-4 mr-2" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" 
                />
              </svg>
              <span className="hidden lg:inline">Sign out</span>
              <span className="lg:hidden">Out</span>
            </button>
          </div>

          {/* Mobile/Tablet Right Section */}
          <div className="flex md:hidden items-center space-x-2 flex-shrink-0">
            {/* Mobile User Avatar */}
            <div className="h-8 w-8 bg-blue-500 rounded-full flex items-center justify-center">
              <span className="text-white text-sm font-medium">
                {user?.email ? user.email.charAt(0).toUpperCase() : 'A'}
              </span>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={toggleMobileMenu}
              className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-150"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 bg-white">
            <div className="px-4 py-3 space-y-3">
              {/* Mobile User Info */}
              <div className="flex items-center space-x-3 pb-3 border-b border-gray-100">
                <div className="h-10 w-10 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white font-medium">
                    {user?.email ? user.email.charAt(0).toUpperCase() : 'A'}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900">{user?.role_id === 2 ? 'Administrator' : user?.role_id === 3 ? 'System Incharge' : user?.role_id === 5 ? 'Super Admin' : 'User'}</p>
                  <p className="text-xs text-gray-500 truncate max-w-48">
                    {user?.email || 'admin@example.com'}
                  </p>
                </div>
              </div>

              {/* Mobile Actions */}
              <div className="space-y-2">
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center px-3 py-2 text-sm font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-150"
                >
                  <svg 
                    className="w-4 h-4 mr-3" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" 
                    />
                  </svg>
                  Sign out
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default AdminHeader;